export default class TextureStack {
    private static _instance?: TextureStack
    private textures: Array<string> = []

    private constructor() {
        if (TextureStack._instance)
            throw new Error("Use Singleton.instance instead of new.");
        TextureStack._instance = this;
    }

    static get instance() {
        return TextureStack._instance ?? (TextureStack._instance = new TextureStack());
    }

    add(path: string) {
        if (this.textures.includes(path)) {
            console.warn('texture already in stack! ' + path)
            return
        }
        this.textures.push(path)
    }

    remove(path: string) {
        if (!this.textures.includes(path)) {
            console.warn('texture cannot removed from stack! ' + path)
            return
        }
        this.textures = this.textures.filter(x => x != path)
    }

    async isEmpty(): Promise<boolean> {
        while (this.textures.length > 0) {
            console.log("Texture stack length: " + this.textures.length)
            await this.sleep(20)
        }
        return true
    }

    private sleep = (ms: number) => new Promise(r => setTimeout(r, ms));
}